import type { TFunction } from 'i18next';

export const SUBSCRIPTION_FREQUENCY = {
  SEMIANNUALLY: 'SEMIANNUALLY',
  ANNUALLY: 'ANNUALLY',
  BIMONTHLY: 'BIMONTHLY',
  TRIMONTHLY: 'TRIMONTHLY',
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
  MINUTELY: 'MINUTELY',
} as const;

export const getFrequencyI18n = ({
  key,
  t,
}: {
  key: string;
  t: TFunction;
}): string => {
  const frequencies: Record<string, string> = {
    [SUBSCRIPTION_FREQUENCY.ANNUALLY]: t('Anually'),
    [SUBSCRIPTION_FREQUENCY.SEMIANNUALLY]: t('Semiannually'),
    [SUBSCRIPTION_FREQUENCY.BIMONTHLY]: t('Bimonthly'),
    [SUBSCRIPTION_FREQUENCY.TRIMONTHLY]: t('Trimonthly'),
    [SUBSCRIPTION_FREQUENCY.MINUTELY]: t('Minutely'),
    [SUBSCRIPTION_FREQUENCY.WEEKLY]: t('Weekly'),
    [SUBSCRIPTION_FREQUENCY.MONTHLY]: t('Monthly'),
  };

  return frequencies[key];
};
